import React, { Component } from 'react'

import TableHeadCellComponent from './TableHeadCell.component'

class TableHeadCellContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sortDirection: null,
      zIndex: 0
    }
  }

  handleMultiSelectChanged = (checkStatus) => {
    this.props.handleSelectAll(!checkStatus)
  }

  /**
 * @description - adjust z-index on mouse rollover of tooltip
 */
  handleMouseEntered = () => {
    this.setState({
      zIndex: 15
    })
  }

  /**
   * @description - adjust z-index on mouse rollover of tooltip
   */
  handleMouseLeft = () => {
    this.setState({
      zIndex: 0
    })
  }

  handleSortClick = () => {
    let sortDirection = null

    if (this.props.header.sortable.enabled) {
      if (!this.state.sortDirection) {
        sortDirection = 'asc'
      }

      if (this.state.sortDirection && this.state.sortDirection === 'asc') {
        sortDirection = 'desc'
      }

      if (this.state.sortDirection && this.state.sortDirection === 'desc') {
        sortDirection = null
      }

      if (sortDirection) {
        this.props.handleSort({
          _order: sortDirection,
          _type: this.props.header.sortable.sortType,
          _sort: this.props.header.datafield,
          _title: this.props.header.title
        })
      } else {
        this.props.handleSort(null)
      }
    }
    this.setState({
      sortDirection
    })

    this.props.analytics.propagateEvent({
      eventType: 'click',
      action: 'Table Head Filter Sort',
      type: 'Datatable'
    })
  }

  render() {
    const events = {
      handleSortClick: this.handleSortClick,
      handleMultiSelectChanged: this.handleMultiSelectChanged,
      handleMouseEntered: this.handleMouseEntered,
      handleMouseLeft: this.handleMouseLeft
    }

    const style = Object.assign({}, this.props.style)

    if (this.state.zIndex > 0) {
      style.zIndex = this.state.zIndex
    }

    if(this.props.actionCellHeader) {
      style.width = `${this.props.header.width}px`
    }

    return (
      <TableHeadCellComponent events={events} newStyle={style} {...this.props} />
    )
  }
}

export default TableHeadCellContainer
